// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { Element } from '@fulcrumapp/fulcrum-core';
import cx from 'classnames';
import { cssInJS } from '../../../utils/styles';

export default class ElementLabel extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    element: PropTypes.instanceOf(Element).isRequired,
  };

  render() {
    const { styles } = ElementLabel;

    return (
      <div className={cx(this.props.className, styles.label)}>
        {this.props.element.label}
      </div>
    );
  }
}

const styles = cssInJS({
  label: {
    width: '40%',
    fontWeight: 'bold',
    paddingLeft: 12,
    paddingTop: 10,
    paddingBottom: 10,

    '@phone': {
      display: 'block',
      width: '100%',
      fontWeight: 'bold',
      paddingTop: 6,
    },
  },
});

ElementLabel.styles = styles;
